import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";

import RightArrow2 from "components/Icons/Arrows/rightArrow2";
import { theme } from "styles/themes";
import * as S from "./styles";

type PendingSeatBannerPropsT = {
  bannerProps: {
    pending_seat_id?: number;
    enterprise_name?: string;
  };
};

const PendingSeatBanner = ({ bannerProps }: PendingSeatBannerPropsT) => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const enterpriseName = bannerProps?.enterprise_name || "An enterprise";
  const pendingSeatId = bannerProps?.pending_seat_id;

  const handleClick = () => {
    const parsed = parse(search);
    parsed.seat_offer_modal = String(pendingSeatId);
    history.push({ pathname, search: stringify(parsed) });
  };

  return (
    <S.BannerContainer role="button" tabIndex={0} onClick={handleClick} onKeyDown={handleClick}>
      <div>
        <S.BoldText>{enterpriseName}</S.BoldText> has invited you to join their team. Click here to review the seat
        offer.
      </div>
      <RightArrow2 fill={theme.colors.darkSeatBannerTeal} />
    </S.BannerContainer>
  );
};

export default PendingSeatBanner;
